import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vRegion from 'v-region'

import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui'

import '@/styles/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import 'babel-polyfill'

Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(vRegion)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
